import { IonTabs as IonicIonTabs } from '@ionic/react'
import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const IonTabs = styled(IonicIonTabs)`
  ion-tab-bar {
    --background: ${myPalette.aliceBlue.main};
    border: none;

    ion-tab-button {
      color: ${myPalette.dark.main};
      padding: 4px;

      &::part(native) {
        &:hover {
          color: ${myPalette.midnightBlue['100']};
        }
      }
      &.tab-selected {
        &::part(native) {
          color: ${myPalette.midnightBlue.main};
        }
      }
    }
  }
`
